import { render, staticRenderFns } from "./tm-order-item.vue?vue&type=template&id=754f2b0e&scoped=true&"
import script from "./tm-order-item.vue?vue&type=script&lang=ts&"
export * from "./tm-order-item.vue?vue&type=script&lang=ts&"
import style0 from "./tm-order-item.vue?vue&type=style&index=0&id=754f2b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754f2b0e",
  null
  
)

export default component.exports